import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Body2 from '../../../../common/typographys/Body2';
import FileBox from '../../../../common/FileBox';
import { downloadProposalResume, downloadProposalSummary } from '../../../../../store/actions/proposalsActions';

const useStyles = makeStyles(() => ({
  fileLabel: {
    marginTop: '25px',
    marginBottom: '10px',
  },
}));

const PointSummaryFile = ({ proposalId, identifierCode, summaryFileName }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const downloadSummary = useCallback(
    file => e => {
      e.preventDefault();

      dispatch(downloadProposalSummary(proposalId, file.name));
    },
    [dispatch, proposalId]
  );

  const downloadResume = useCallback(
    // eslint-disable-next-line no-unused-vars
    _file => e => {
      e.preventDefault();

      dispatch(downloadProposalResume(proposalId, identifierCode));
    },
    [dispatch, proposalId, identifierCode]
  );

  if (!proposalId) {
    return null;
  }

  return (
    <>
      <Body2 className={classes.fileLabel}>Ficheiro resumo</Body2>
      {summaryFileName ? (
        <FileBox file={{ name: summaryFileName }} download downloadFile={downloadSummary} />
      ) : (
        <FileBox file={{ name: `${identifierCode}.pdf` }} download downloadFile={downloadResume} />
      )}
    </>
  );
};

PointSummaryFile.defaultProps = {
  proposalId: null,
  identifierCode: null,
  summaryFileName: null,
};

PointSummaryFile.propTypes = {
  proposalId: PropTypes.number,
  identifierCode: PropTypes.string,
  summaryFileName: PropTypes.string,
};

export default React.memo(PointSummaryFile);
